import DatePicker from "../../common/DatePicker";

export default {
  filter_date_from: {
    label: 'Filter From',
    placeholder: 'Pick a date',
    value: '',
    errors: [],
    style: {
      grid: null,
    },
    system: {
      component: DatePicker,
      name: null,
    },
    rules: {
      title: null,
    },
    timeFormat: false,
  },
  filter_date_to: {
    label: 'Filter To',
    placeholder: 'Pick a date',
    value: '',
    errors: [],
    style: {
      grid: null,
    },
    system: {
      component: DatePicker,
      name: null,
    },
    rules: {
      title: null,
    },
    timeFormat: false,
  },
};



// WEBPACK FOOTER //
// ./src/containers/ArchiveListWO/field.js